import { Component, OnInit } from '@angular/core';
import { HighlightService } from 'src/app/@core/services/highligh.service';
@Component({
  selector: 'app-inicio-sesion',
  templateUrl: './inicio-sesion.component.html',
  styleUrls: ['./inicio-sesion.component.scss']
})
export class InicioSesionComponent implements OnInit {

  arrayComponent: any;
  highlighted: boolean = false;
  componentRender: any;
  infoComponent: any;
  jsCodeImplement: any;
  constructor(private highlightService: HighlightService) {
    this.jsCodeImplement =
    `
      <script src="https://cdn.www.gov.co/v2/assets/js/utils.js"></script>
      <script type='text/javascript'>
        utils.showPasswordCheckbox("inputPassword-govco","checkboxPassword-govco")
      </script>
    `;
    this.arrayComponent = [
      {
        id: 'simbolicos',
        titulo: 'Botones Simbólicos',
        subtitulo: 'Compuesto por un ícono que representa gráficamente una acción y opcionalmente puede estar acompañado de un título que describe la acción del botón.',
        claseContainer: 'col-12',
        componentRender: `
        <div class="govco-form-signin">
          <form >
            <div clas="text-center">
              <span class=" bd-highlight govco-icon govco-icon-key-cn"></span>
            </div>
            <h3 class="govco-title-sign-form headline-l-govco">Inicio de sesión</h3>
            <div class="form-group">
              <label for="inputEmail-govco">Correo electrónico</label>
              <input type="text" class="form-control input-govco" placeholder="" id="inputEmail-govco" required>
            </div>
            <div class="form-group">
              <label for="inputPassword-govco">Contraseña</label>
              <input type="password" class="form-control input-govco" placeholder="" id="inputPassword-govco" required>
            </div>

            <div class="checkbox mb-3">
              <label class="checkbox-govco">
                  <input type="checkbox" id="checkboxPassword-govco" />
                  <label class="label_checkbox" for="checkboxPassword-govco"> Mostrar contraseña</label>
              </label>
            </div>
            <div class="d-flex d-flex justify-content-between">
              <button type="reset" class="btn-round btn-middle">CANCELAR</button>
              <button type="submit" class="btn btn-round btn-high mr-0">INGRESAR</button>
            </div>
          </form>
          <div class="govco-form-sign-links">
            <a href="/" class="btn-low">Olvidé mi contraseña</a>
            <a href="/" class="btn-low">Registrarme</a>
          </div>
        </div>

`,
      }
    ]

    this.infoComponent = {
      titulo: "Inicio de Sesión",
      descripcion: ""
    }
  }

  ngAfterViewChecked() {
    if (!this.highlighted) {
      this.highlightService.highlightAll();
      this.highlighted = true;
    }
  }
  ngOnInit() {
    window.utils.init();
  }

  ngAfterViewInit() {
    window.utils.showPasswordCheckbox("inputPassword-govco","checkboxPassword-govco");
  }
}